const recurly = {
  linkHref: "https://app.recurly.com/login",
  confirmTeam: "Recurly",
  steps: [
    { text: "Log in to the [[Recurly Dashboard]]" },
    { text: "Navigate to **Admin → Roles**" },
    { text: "Click **Create Role** in the top right corner of the screen." },
    { text: "Name and describe the role" },
    {
      text: "Configure permissions:",
      subSteps: ["Role name: **Chargeback team**", "Allow access checkbox", "Read-only permissions"]
    },
    { text: "From the main menu, navigate to **Admin → Users → User Actions → Invite Users**." },
    { text: "Enter the email address {{email}}" },
    { text: "Select **the created** role" },
    { text: "Then click **Send Invite**" },
    { text: "**Return here, tick the box below, and submit your request**" }
  ]
}

const airwallex = {
  linkHref: "https://www.airwallex.com/app/uam/roles",
  confirmTeam: "Airwallex",
  steps: [
    { text: "Log in to the [[Airwallex Dashboard]]" },
    { text: "Go to **Settings → Roles**, then click **Create custom role**" },
    { text: "Add Role name: **Chargeback Admin**" },
    {
      text: "**Set up account permissions**",
      subSteps: [
        "Wallet → Cash: View transactions checkbox",
        "Payments → Payments: View checkbox",
        "Click **Create role** button"
      ]
    },
    { text: "Go to **Settings → User management**" },
    { text: "Click **Invite user** button in the top right corner of the screen." },
    {
      text: "**Create a new user:**",
      subSteps: [
        "Display name: **Chargeback team**",
        "Email: {{email}}",
        "Roles: choose the created **Chargeback Admin** role",
        "Select **Employment entity**",
        "Click **Send invitation** button"
      ]
    },
    { text: "**Return here, tick the box below, and submit your request**" }
  ]
}

const adyen = {
  linkHref: "https://ca-live.adyen.com/ca/ca/login",
  confirmTeam: "Adyen",
  steps: [
    { text: "Log in to the [[Adyen Dashboard]]" },
    { text: "Switch to the **merchant account (store)** you want to give access to." },
    { text: "Go to **Settings → Users**." },
    { text: "Click **Create new user**." },
    { text: "Select **Email and password** as the login method" },
    { text: "Enter the user's email address: {{email}}" },
    { text: "Select the accounts you want to access." },
    { text: "Assign the required **Role: Transactions → View Payments**" },
    {
      text: "Make sure the **Chargeback Admin** role is assigned to the required **merchant account**."
    },
    { text: "Review the details and click **Create new user**." },
    { text: "**Return here, tick the box below, and submit your request**" }
  ]
}

const braintree = {
  linkHref: "https://www.braintreegateway.com/login",
  confirmTeam: "Braintree",
  steps: [
    { text: "Log in to your [[Braintree Control Panel]]." },
    { text: "Go to **Settings → Roles**." },
    { text: "Add **Role Details: Chargeback Admin**" },
    {
      text: "Choose **Rights Granted:**",
      subSteps: [
        "Transactions: Download Transactions with Masked Payment Data",
        "Read-Only Access: View Transactions",
        "Search: Search Transactions"
      ]
    },
    { text: "Click **Create role**" },
    { text: "Go to **Settings → Users**" },
    { text: "Click **New User**" },
    {
      text: "Enter the new user's details:",
      subSteps: ["Email address: {{email}}", "Roles: created **Chargeback Admin**"]
    },
    { text: "Select the **merchant account** the **Chargeback Admin** should have access to." },
    { text: "Assign the required **role/permissions**." },
    { text: "Click **Create user** button" },
    { text: "**Return here, tick the box below, and submit your request**" }
  ]
}

const authorizeNet = {
  linkHref: "https://login.authorize.net/",
  confirmTeam: "Authorize.net",
  steps: [
    { text: "Log in to your [[Authorize.net Merchant Interface]]." },
    { text: "Go to **Account → Manage Users**." },
    { text: "Click **+ Add New User**." },
    {
      text: "Enter the **Chargeback Admin** details:",
      subSteps: ["Login ID: Chargeback Admin", "Email address: {{email}}", "Phone number"]
    },
    { text: "Select the required **User Role: Account Analyst**" },
    { text: "Click **Save** button" },
    { text: "**Return here, tick the box below, and submit your request**" }
  ]
}

const nmi = {
  linkHref: "https://secure.nmi.com/merchants/login.php",
  confirmTeam: "NMI",
  steps: [
    { text: "Log in to your [[NMI Merchant Portal]]." },
    {
      text: "From the homepage under **Utilities**, click **Settings**, then under **General Options** click **User Accounts**."
    },
    { text: "Click **Add A New User**." },
    {
      text: "Enter user information:",
      ordered: false,
      subSteps: [
        "Username: Chargeback Admin",
        "First Name / Last Name: Chargeback Team",
        "Email: {{email}}"
      ]
    },
    { text: "Permissions: **Access transaction reports**" },
    { text: "Click **Create User**." },
    { text: "**Return here, tick the box below, and submit your request**" }
  ]
}

const nextCommerce = {
  linkHref: "https://accounts.29next.com/accounts/login/",
  confirmTeam: "Next Commerce",
  steps: [
    { text: "Log in to your [[Next Commerce Dashboard]]" },
    { text: "Go to **Store Settings → Users & Permissions**." },
    { text: "Click **Add Dashboard User**." },
    { text: "Enter the **Chargeback Admin** email address: {{email}}" },
    { text: "First name/Last name: **Chargeback Admin**" },
    { text: "Store Permissions: **Payments**" },
    { text: "Click **Save Changes** button" },
    { text: "**Return here, tick the box below, and submit your request**" }
  ]
}

const shopify = {
  intro:
    "The Automatic Credits feature allows the Chargeback team to process your requests for system credits and provide the necessary evidence.",
  steps: [
    {
      text: "Submit your Credit Automation request and wait for a Chargeback Admin to send a collaborator access request from {{email}} to your Shopify account."
    }
  ]
  // CHA1-3281: "Accept within 5 min" + "Do not change permissions" moved to the second pop-up
  // (ShopifyActivateAccessModal), shown after Submit.
}

export const contentMap = {
  recurly,
  airwallex,
  adyen,
  braintree,
  "authorize.net": authorizeNet,
  authorize: authorizeNet,
  nmi,
  next: nextCommerce,
  nextcommerce: nextCommerce,
  shopify
}
